import { LDValueType } from '../../auth/services/PresetService';
import { AppConfigContext } from '../../common/services/AppConfigContext';

export enum FeatureFlagsType {
  // UI features
  ENABLE_JIRA_BATCH_EXPORT = 'EnableJiraBatchExport',

  // Backend features
  DEPRECATE_FUZZER_PROFILES = 'DeprecateFuzzerProfiles',
  ENABLE_AUTH_TAGS = 'EnableAuthTags',
  ENABLE_IDP_AUTHORIZATION = 'EnableIdpAuthorization',
  ENABLE_OIDC_TOKEN_ENDPOINT = 'EnableOidcTokenEndpoint',
  ENABLE_ORGANIZATION_USER_ROLES = 'EnableOrganizationUserRoles',
  ENABLE_PYTHON_TRACING = 'EnablePythonTracing',
  ENABLE_QUALYS = 'EnableQualys',
  ENABLE_SERVICE_NOW = 'EnableServiceNow',
  ENABLE_TANIUM_INTEGRATION = 'EnableTanium',

  // Custom values
  CONTROL_CENTER_BUG_REPORT_URL = 'ControlCenterBugReportUrl',

  // Additional backend flags (not coming from LaunchDarkly)
  ENABLE_GRAPHQL_INTROSPECTION = 'EnableGraphQLIntrospection',
}

/**
 * Gets the value of the specified feature flag.
 *
 * @param {FeatureFlagsType} featureFlagsType - the feature flag to assess
 * @return {boolean} - the flag value
 */
export function getFeatureFlag<T extends LDValueType = boolean>(featureFlagsType: FeatureFlagsType): T | null {
  const flags = AppConfigContext.getPresets().featureFlags;
  return (flags[featureFlagsType] as T) ?? null;
}
